import { render, staticRenderFns } from "./AdminComponent.vue?vue&type=template&id=6da9e65e&scoped=true"
import script from "./AdminComponent.vue?vue&type=script&lang=js"
export * from "./AdminComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da9e65e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6da9e65e')) {
      api.createRecord('6da9e65e', component.options)
    } else {
      api.reload('6da9e65e', component.options)
    }
    module.hot.accept("./AdminComponent.vue?vue&type=template&id=6da9e65e&scoped=true", function () {
      api.rerender('6da9e65e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminComponent.vue"
export default component.exports